import { gql } from "@apollo/client";

const ASSIGN_PRODUCTS = gql`
  mutation assignProductsLocation($location: ID, $products: [ID!]) {
    assignProductsLocation(location: $location, products: $products)
  }
`;

const GET_PRODUCTS = gql`
  query products($params: QueryParams, $name: String) {
    products(params: $params, name: $name) {
      info {
        count
      }
      results {
        id
        name
        description
        type
        variants {
          id
          title
          img
          description
          price
          isPrimaryVariant
          product {
            id
            name
            description
          }
        }
      }     
    }
  }
`;

export { ASSIGN_PRODUCTS, GET_PRODUCTS };
